import { Text, TextProps } from '@chakra-ui/react';
import React from 'react';
import colors from '../../utils/colors';

interface BodyTextProps extends TextProps {
    children: React.ReactNode;
    size: "xs" | "s"
    color?: string
    fontSize?: string
    fontWeight?: number
}

const BodyText: React.FC<BodyTextProps> = ({ fontWeight, children, fontSize, color, size, ...rest }) => {
    return <Text
        {...rest}
        fontSize={fontSize ? fontSize : size === "xs" ? "12px" : "18px"}
        fontFamily={"lato"}
        fontWeight={fontWeight ?? 400}
        color={color ?? colors.placeholderColor}
        lineHeight={size === "xs" ? "14.4px" :"21.6px"}
    >
        {children}
    </Text>;
};

export default BodyText;
